







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TimeLeft extends Vue {
    @Prop()
    value: number;

    @Prop({ default: 1 })
    refresh: number;

    @Prop({ default: false })
    displaySeconds: boolean;

    @Prop({ default: false })
    showAll: boolean;

    public timeLeft: number = null;

    public interval: any = null;

    private minutesMultiplier = 60;

    private hoursMultiplier = this.minutesMultiplier * 60;

    private dayMultiplier = this.hoursMultiplier * 24;

    get timeLeftString(): string {
        if (!this.timeLeft) {
            return this.$t('time.ran_out').toString();
        }

        return `${this.daysLeftString} ${this.hoursLeftString} ${this.minutesLeftString} ${this.secondsLeftString}`.trim();
    }

    get daysLeftString(): string {
        return this.daysLeft > 0 ? `${this.daysLeft}${this.$t('time.days')}` : '';
    }

    get hoursLeftString(): string {
        return this.hoursLeft > 0 || this.showAll ? `${this.hoursLeft}${this.$t('time.hours')}` : '';
    }

    get minutesLeftString(): string {
        return this.minutesLeft > 0 || this.showAll ? `${this.minutesLeft}${this.$t('time.minutes')}` : '';
    }

    get secondsLeftString(): string {
        if (this.displaySeconds || (this.daysLeft === 0 && this.hoursLeft === 0)) {
            const secondsLeft = this.timeLeftExcludingDaysAndHours - this.minutesLeft * this.minutesMultiplier;

            return `${secondsLeft}${this.$t('time.seconds')}`;
        }

        return '';
    }

    get daysLeft(): number {
        return Math.floor(this.timeLeft / this.dayMultiplier);
    }

    get timeLeftExcludingDays(): number {
        return this.timeLeft - this.daysLeft * this.dayMultiplier;
    }

    get hoursLeft(): number {
        return Math.floor(this.timeLeftExcludingDays / this.hoursMultiplier);
    }

    get timeLeftExcludingDaysAndHours(): number {
        return this.timeLeftExcludingDays - this.hoursLeft * this.hoursMultiplier;
    }

    get minutesLeft(): number {
        return Math.floor(this.timeLeftExcludingDaysAndHours / 60);
    }

    created() {
        this.timeLeft = this.value;

        if (this.timeLeft) {
            this.interval = setInterval(() => {
                this.timeLeft -= this.refresh;
                if (!this.timeLeft) {
                    this.clearInterval();
                }
                this.$emit('input', this.timeLeft);
            }, (this.refresh * 1000));
        }
    }

    destroyed(): void {
        this.clearInterval();
    }

    clearInterval() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}
